/**
 * Ad Section
 * Theme section wrapper for AdPlacement component
 * Only renders if the merchant has ad feature access
 */

import React from 'react';
import AdPlacement from '../ads/AdPlacement';
import './sections.css';

const AD_PLACEMENTS = [
  { value: 'HOMEPAGE_HERO', label: 'Homepage Hero' },
  { value: 'HOMEPAGE_BANNER', label: 'Homepage Banner' },
  { value: 'SHOP_INLINE', label: 'Shop Inline' },
  { value: 'SHOP_SIDEBAR', label: 'Shop Sidebar' },
  { value: 'CATEGORY_INLINE', label: 'Category Inline' },
  { value: 'ABOUT_BANNER', label: 'About Banner' },
];

function AdSection({ settings = {}, content = {}, globalStyles = {}, store }) {
  const {
    placement = 'HOMEPAGE_BANNER',
    showAdvertiseBlurb = true,
    maxAds = 1,
    backgroundColor = 'transparent',
    padding = '20px 0',
  } = settings;

  const storeSlug = store?.slug;

  if (!storeSlug) {
    return null;
  }

  const containerStyle = {
    backgroundColor,
    padding,
  };

  return (
    <section className="ts-ad-section" style={containerStyle}>
      <div className="ts-ad-section__container">
        <AdPlacement
          storeSlug={storeSlug}
          placement={placement}
          showAdvertiseBlurb={showAdvertiseBlurb}
          maxAds={maxAds}
        />
      </div>
    </section>
  );
}

// Export placement options for settings panel
export { AD_PLACEMENTS };
export default React.memo(AdSection);
